/**
 * .disable-on-click
 * When an element with .btn.disable-on-click is clicked, this element is disabled
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;$(function(){

    "use strict";

    /**
     * Define selector
     *
     * @type {String}
     */
    var $selector =  '.disable-on-click';

    /**
     * Define method as a property
     *
     * @return closure
     */
    var disableOnClick = function(){
        $($selector).on('click', function (event) {
            $(this).addClass('disabled').prop('disabled', true);
        });
    }
    // Bind the method to Document
    $(document).ready(disableOnClick);
    // Bind the loaded.bs.modal to bind to remote modals
    $('#remote').on('loaded.bs.modal', disableOnClick);
});
